import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";

import PatterField from "./PatternField/PatternField";

import { clearPattern, getPattern, postPattern } from "../../../redux/patternsReducer/actionsPatterns";

import styles from "./PatternsContainer.module.css";

function PatternsContainer({ title, url, id, setShowModal }) {
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { patternFields } = useSelector((state) => state.patternsReducer);

  useEffect(() => {
    dispatch(getPattern(url, id));
    return () => {
      dispatch(clearPattern());
    };
  }, []);

  const onSubmit = (data) => {
    dispatch(postPattern(url, data, id));
    setShowModal(true);
    navigate(-1);
  };

  return (
    <div className={styles["container"]}>
      <h2 className={styles["main-text"]}>{title}</h2>
      <div className={styles["content-container"]}>
        <form className={styles["container-fields"]}>
          {patternFields.map((item) => (
            <PatterField
              key={item.key}
              item={item}
              register={register}
              errors={errors}
              setValue={setValue}
            />
          ))}
        </form>
        <div className={styles["buttons-block"]}>
          <button
            className={styles["close-btn"]}
            onClick={() => {
              navigate(-1);
            }}>
            Закрыть
          </button>
          <button
            className={styles["add-btn"]}
            onClick={handleSubmit(onSubmit)}>
            Сохранить
          </button>
        </div>
      </div>
    </div>
  );
}

export default PatternsContainer;
